<template>
    <li data-mobile-menu-item>
        <a href="" data-mobile-menu-trigger>
            {{menu_title}}
            <svg width="7" height="11">
            <path
                d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z"
            />
            </svg>
        </a>
        <div class="mobile-menu__links-panel" data-mobile-menu-panel>
            <div class="mobile-menu__panel mobile-menu__panel--hidden">
            <div class="mobile-menu__panel-header">
                <button class="mobile-menu__panel-back" type="button">
                <svg width="7" height="11">
                    <path
                    d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"
                    />
                </svg>
                </button>
                <div class="mobile-menu__panel-title">{{menu_title}}</div>
            </div>
            <div class="mobile-menu__panel-body">
                <ul class="mobile-menu__links">
                    <li data-mobile-menu-item v-for="(cat1, index) in level1" :key="index">
                        <!-- <a href="/category" class="" data-mobile-menu-trigger> -->
                        <router-link data-mobile-menu-trigger :to="'/category/1/' + cat1.categorycode">
                            {{cat1.categoryname}}

                            <svg width="7" height="11"  v-if="cat1.subcategories.length > 0">
                                <path d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9	C-0.1,9.8-0.1,10.4,0.3,10.7z"/>
                            </svg>
                        </router-link>
                        <div class="mobile-menu__links-panel" data-mobile-menu-panel>
                            <div class="mobile-menu__panel mobile-menu__panel--hidden">
                                <div class="mobile-menu__panel-header">
                                    <button class="mobile-menu__panel-back" type="button">
                                        <svg width="7" height="11">
                                        <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"/>
                                        </svg>
                                    </button>
                                    <div class="mobile-menu__panel-title">{{cat1.categoryname}}</div>
                                </div>
                                <div class="mobile-menu__panel-body">
                                    <ul class="mobile-menu__links">
                                        <li data-mobile-menu-item v-for="(cat2, index2) in cat1.subcategories" :key="index2"  @click="close(cat2.subcategories.length)">
                                            <router-link data-mobile-menu-trigger :to="'/category/2/' + cat2.DMCD01 + '/'+ cat2.categorycode">
                                                {{cat2.categoryname}}

                                                <svg width="7" height="11"  v-if="cat2.subcategories.length > 0">
                                                    <path
                                                    d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9	C-0.1,9.8-0.1,10.4,0.3,10.7z"
                                                    />
                                                </svg>
                                            </router-link>

                                            <div class="mobile-menu__links-panel" data-mobile-menu-panel v-if="cat2.subcategories.length > 0">
                                                <div class="mobile-menu__panel mobile-menu__panel--hidden">
                                                    <div class="mobile-menu__panel-header">
                                                        <button class="mobile-menu__panel-back" type="button">
                                                            <svg width="7" height="11">
                                                            <path
                                                                d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"
                                                            />
                                                            </svg>
                                                        </button>
                                                        <div class="mobile-menu__panel-title">{{cat2.categoryname}}</div>
                                                    </div>
                                                    <div class="mobile-menu__panel-body">
                                                        <ul class="mobile-menu__links">
                                                            <li data-mobile-menu-item v-for="(cat3, index3) in cat2.subcategories" :key="index3" @click="close(0)">
                                                                <router-link data-mobile-menu-trigger :to="'/category/3/' + cat2.DMCD01 + '/' + cat2.DMCD02 + '/' + cat3.categorycode">
                                                                    {{cat3.categoryname}}
                                                                </router-link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
            </div>
        </div>
    </li>
</template>
<script>
export default {
    data() {
        return {
            categories: [],
            isloading: true,
        };
    },

    props: {
        level1: {
            type: Array,
            required: true
        },
        menu_title: {
            type: String
        }
    },
    methods: {
        sizeMenu(menu) {
            let length = menu.hassubs.length;

            let classname = "departments__megamenu--size--nl";
            menu.max = 1;
            if (length == 1 || length == 2) {
            classname = "departments__megamenu--size--nl";
            menu.classCol = "col-6";
            menu.max = 2;
            } else if (length == 3) {
            classname = "departments__megamenu--size--lg";
            menu.classCol = "col-3";
            menu.max = 3;
            } else if (length > 3) {
            classname = "departments__megamenu--size--xl";
            menu.classCol = "col-2";
            menu.max = 6;
            }
            return classname;
        },

        close(children){
            if(children === 0){
                this.$emit('close');
            }
            
        }
    },
  computed: {
    primaryCategories() {
        const categories = this.$store.getters['product/categories'];
        return categories.filter((cat) => {
            return cat.categorylevel === 1;
        });
    },
  },
};
</script>